import React from 'react'
import { styles } from './styles'
import { formatterFunction } from './util'

const FontComponent = ({
  content,
  fontColor = 'default',
  contentType,
  fontWeight = 'inherit',
  dateFormat,
  fontSize,
  showRupeeSymbol = true
}: {
  content: string
  contentType?: 'amount' | 'name' | 'date'
  dateFormat?: 'DD MMM' | 'DD MMM, hh:mm A' | 'DD MMM YYYY'
  fontColor?: 'primary' | 'secondary' | 'danger' | 'default' | 'tertiary' | 'grayscale'
  fontWeight?: number | string
  fontSize?: number | string
  showRupeeSymbol?: boolean
}) => {
  const classes = styles({ fontWeight, fontColor, fontSize })
  return (
    <span className={classes.fontStyle}>
      {formatterFunction({
        type: contentType || 'amount',
        value: content,
        dateFormat,
        showRupeeSymbol
      })}
    </span>
  )
}

export default FontComponent
